module.exports = __webpack_public_path__ + "static/media/tony.cd4519d2.jpg";